import type { TenantConfig } from '@/types/TenantConfig'

export const kidzplay: TenantConfig = {
  logo: 'assets/kidzplay/static/logo.png',
  themeOptions: {
    dialog: {
      backgroundColor: '#f0f2f7',
      headerBackground: '#00066b',
      headerTextColor: '#ffffff',
      headerIconColor: '#ffffff',
    },
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/kidzplay/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-200px',
        mobile: '-150px',
      },
    },
  },
}
